import { ReactComponent as OverviewIcon } from "../img/topbar/overviewIcon.svg"


export const pageConfig = {
  "/": {
    title: "Overview",
    icon: <OverviewIcon />
  },
  "/Cryptoprices": {
    title: "Cryptoprices",
    icon: <OverviewIcon />
  },
  "/Products": {
    title: "Products",
    icon: <OverviewIcon />
  },
  "/Portfolio": {
    title: "My Portfolio",
    icon: <OverviewIcon />
  },
  "/News": {
    title: "News",
    icon: <OverviewIcon />
  },
  "/Transactions": {
    title: "Transactions",
    icon: <OverviewIcon />
  },
  "/Settings": {
    title: "Settings",
    icon: <OverviewIcon />
  },
  "/notification": {
    title: "Notifications",
    icon: <OverviewIcon />
  },
};